import React from 'react';
import { useEffect } from 'react';
import AOS from 'aos';

import 'aos/dist/aos.css';
import '../Pages/Style.css';

const Job = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,  // animation time in ms
            once: true,      // animate only once when scrolling down
            easing: 'ease-in-out',
            offset: 120,
        });
    }, []);

    return (
        <div id='content' >
            {/* Background image section with left text */}
            <div
                className="home-background d-flex align-items-start"
                id="job-background"
                style={{
                    backgroundImage: `url('/Photos/123217.jpg')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top',
                    height: '450px',
                    color: 'white' // optional: white text for better contrast
                }}
            >
                <div className="w-100 text-end p-4 pt-5 me-4">
                    <h1 className="text-whitee">Jobs</h1>
                </div>
            </div>
            <div className="container py-5" data-aos="fade-up">
                <h3 className="text-primary mb-4" id='JOB'>ADVANCE YOUR CAREER WITH DELIGHT CONSULTANCY</h3>


            </div>
            <div class="container mt-4" data-aos="fade-up" >
                <div class="row g-4" id='job-con'>

                    <div class="col-md-4">
                        <div class="job-box">
                            <h5>International Technical Process Specialist</h5>
                            <p>Looking for Technically Skilled Candidates with excellent Interpersonal Skills for:</p>
                            <ul>
                                <li className='text-dark'>Technical Support / Laptop Support</li>
                                <li className='text-dark'>Service Desk / International semi voice / Chat support</li>
                                <li className='text-dark'>Multiple Chat / Dual Chat Experience Required</li>
                            </ul>
                            <p><strong>Exp:</strong> 2+ yrs (Mandatory)</p>
                            <p><strong>Education:</strong> BCA, BSC, BE, BTECH (CS/IT)</p>
                            <p><strong>Salary:</strong> Upto ₹6 LPA</p>
                            <p>Immediate Joiners | 5 Days Working | Work From Office</p>
                            <p><strong>Location:</strong> Bangalore</p>
                        </div>
                    </div>


                    <div class="col-md-4">
                        <div class="job-box">
                            <h5>Customer Support - Banking Voice Process</h5>
                            <p><strong>Education:</strong> 10+2 / Any Graduate</p>
                            <p><strong>Experience:</strong> 0 to 1+ year</p>
                            <p><strong>Salary:</strong> Upto ₹4.25 LPA + Retention Bonus</p>
                            <p><strong>Skills:</strong> Excellent Communication</p>
                            <p>Immediate Joiners</p>
                            <p><strong>Location:</strong> Bangalore</p>
                        </div>
                    </div>


                    <div class="col-md-4">
                        <div class="job-box">
                            <h5>Banking Process</h5>
                            <p><strong>Education:</strong> Any Graduate</p>
                            <p><strong>Experience:</strong> 1 year BPO + 6 months Banking</p>
                            <p><strong>Languages:</strong></p>
                            <ul>
                                <li className='text-dark'>English + Hindi</li>
                                <li className='text-dark'>English + Kannada</li>
                                <li className='text-dark'>English + Tamil</li>
                                <li className='text-dark'>English + Malayalam</li>
                            </ul>
                            <p><strong>Salary:</strong> ₹33K CTC – ₹27K NTH</p>
                            <p><strong>Shift:</strong> Day Rotational (8 AM – 8 PM)</p>
                            <p><strong>Week Off:</strong> 1 Rotational Off</p>
                            <p><strong>Cab:</strong> Not Available</p>
                            <p><strong>Location:</strong> Bangalore</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container mt-4" data-aos="fade-up" id='job-content'>
                <div class="row g-4">

                    <div class="col-md-4">
                        <div class="job-box">
                            <h5>Banking Process</h5>
                            <p><strong>Education:</strong> Any Graduate</p>
                            <p><strong>Experience:</strong> Fresher</p>
                            <p><strong>Languages:</strong></p>
                            <ul>
                                <li className='text-dark'>English + Hindi</li>
                                <li className='text-dark'>English + Kannada</li>
                                <li className='text-dark'>English + Tamil</li>
                                <li className='text-dark'>English + Malayalam</li>
                            </ul>
                            <p><strong>Salary:</strong> ₹19,500 CTC / ₹15,000 In-hand</p>
                            <p><strong>Shift:</strong> Day Rotational (8 AM – 8 PM)</p>
                            <p><strong>Week Off:</strong> 1 Rotational Off</p>
                            <p><strong>Cab:</strong> Not Available</p>
                            <p><strong>Location:</strong> Bangalore</p>
                        </div>
                    </div>


                    <div class="col-md-4">
                        <div class="job-box">
                            <h5>Customer Support - Semi Voice Process</h5>
                            <p><strong>Qualification:</strong> Any Graduate</p>
                            <p><strong>Experience:</strong> 1 Year (Mandatory)</p>
                            <p><strong>Languages:</strong> Fluent in English, Average in Hindi</p>
                            <p><strong>Shift:</strong> Day Shift (Domestic Process)</p>
                            <p><strong>Mode:</strong> Work from Office</p>
                            <p><strong>CTC:</strong> Up to ₹24,500/month</p>
                            <p><strong>Take Home:</strong> Up to ₹19,800/month</p>
                            <p><strong>Quarterly Bonus:</strong> ₹4,065</p>
                            <p><strong>Location:</strong> Bangalore</p>
                        </div>
                    </div>


                    <div class="col-md-4">
                        <div class="job-box">
                            <h5>Customer Support</h5>
                            <p><strong>Mode:</strong> Work from Office</p>
                            <p><strong>Shift:</strong> Day Shift</p>
                            <p><strong>Qualification:</strong> Any Graduate with min 6 months exp or MBA Fresher</p>
                            <p><strong>Languages:</strong> Fluent in English (Versant Level 4) and Hindi</p>
                            <p><strong>Working Days:</strong> 6 Days / 1 Rotational Off</p>
                            <p><strong>CTC:</strong> Up to ₹30,000/month</p>
                            <p><strong>Location:</strong> Bangalore</p>
                            <p><strong>Note:</strong> Only Female Candidates</p>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    );
};
export default Job;
